class TabRowComponent extends HTMLElement {
  #controller = new AbortController();

  connectedCallback() {
    const source = this.querySelector(':scope > [data-tab-row-source]');
    const tabsContainer = this.querySelector(':scope > [data-tab-row-tabs]');
    const panelsContainer = this.querySelector(':scope > [data-tab-row-panels]');

    if (!source || !tabsContainer || !panelsContainer) return;

    // Move buttons and panels rendered by `_tab-pane` children out of the
    // hidden source container into their final positions.
    source.querySelectorAll(':scope > .tab-row__tab').forEach((tab) => {
      tabsContainer.appendChild(tab);
    });
    source.querySelectorAll(':scope > .tab-row__panel').forEach((panel) => {
      panelsContainer.appendChild(panel);
    });

    // The hidden source container has served its purpose.
    source.remove();

    const { signal } = this.#controller;
    tabsContainer.addEventListener(
      'click',
      this.#handleTabClick,
      { signal }
    );

    // Activate the first tab on initial render.
    const firstTab = tabsContainer.querySelector('.tab-row__tab');
    if (firstTab instanceof HTMLElement) {
      this.#activate(firstTab.dataset.tabPane);
    }
  }

  disconnectedCallback() {
    this.#controller.abort();
  }

  /** @param {Event} event */
  #handleTabClick = (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;
    const tab = target.closest('.tab-row__tab');
    if (!(tab instanceof HTMLElement)) return;
    const paneId = tab.dataset.tabPane;
    if (!paneId) return;
    this.#activate(paneId);
  };

  /** @param {string | undefined} paneId */
  #activate(paneId) {
    if (!paneId) return;

    this.querySelectorAll('.tab-row__tab').forEach((tab) => {
      if (!(tab instanceof HTMLElement)) return;
      const isActive = tab.dataset.tabPane === paneId;
      if (isActive) {
        tab.setAttribute('data-tab-active', '');
        tab.setAttribute('aria-selected', 'true');
      } else {
        tab.removeAttribute('data-tab-active');
        tab.setAttribute('aria-selected', 'false');
      }
    });

    this.querySelectorAll('.tab-row__panel').forEach((panel) => {
      if (!(panel instanceof HTMLElement)) return;
      const isActive = panel.dataset.tabPane === paneId;
      if (isActive) {
        panel.setAttribute('data-tab-active', '');
      } else {
        panel.removeAttribute('data-tab-active');
      }
    });
  }
}

if (!customElements.get('tab-row-component')) {
  customElements.define('tab-row-component', TabRowComponent);
}
